import { apiFetch } from "@/client/lib/api";
import type { CapacityRequestAnswers } from "@/shared/capacity-request";

export interface CapacityRequestView {
  id: string;
  email: string;
  emailVerified: boolean;
  company: string | null;
  contactName: string | null;
  role: string | null;
  status: "draft" | "submitted";
  answers: CapacityRequestAnswers;
  submittedAt: string | null;
  slackThreadTs: string | null;
  slackNotificationError: string | null;
  updatedAt: string;
}

export interface CapacityRequestNotification {
  status: "sent" | "already_sent" | "skipped" | "failed" | "in_progress" | "not_submitted";
  slackThreadTs?: string;
  error?: string;
}

export interface CapacityRequestDraftPatch {
  company?: string;
  contactName?: string;
  role?: string;
  answers?: CapacityRequestAnswers;
}

export interface CapacityRequestSubmission {
  company: string;
  contactName: string;
  role: string;
  answers: CapacityRequestAnswers;
}

export const capacityRequestApi = {
  start(email: string): Promise<void> {
    return apiFetch("/intake/start", { method: "POST", json: { email } });
  },

  async verify(token: string): Promise<CapacityRequestView> {
    const body = await apiFetch<{ request: CapacityRequestView }>("/intake/verify", {
      method: "POST",
      json: { token },
    });
    return body.request;
  },

  async draft(): Promise<CapacityRequestView> {
    const body = await apiFetch<{ request: CapacityRequestView }>("/intake/draft");
    return body.request;
  },

  async save(patch: CapacityRequestDraftPatch): Promise<CapacityRequestView> {
    const body = await apiFetch<{ request: CapacityRequestView }>("/intake/draft", {
      method: "PATCH",
      json: patch,
    });
    return body.request;
  },

  async submit(submission: CapacityRequestSubmission): Promise<{
    request: CapacityRequestView;
    notification: CapacityRequestNotification;
  }> {
    return apiFetch("/intake/submit", { method: "POST", json: submission });
  },
};
